import React from "react";
import { SovosChipFilter, SovosIcon } from "mosaic-react";
import { CircleRounded } from "mosaic-react-icons";
import { useTheme } from "mosaic-react/styles";
import styles from "./AuditStatus.module.sass";
const AuditStatus = props => {
  const {
    value
  } = props;
  const theme = useTheme();
  const {
    color,
    family,
    severity,
    label
  } = value || {};
  const colorToCircle = family && color && theme.palette?.[family]?.[color] ? theme.palette[family][color] : "";
  const circleRoundedStyle = {
    position: "relative",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    display: "block",
    margin: "auto",
    fontSize: 11,
    color: colorToCircle
  };
  const sovosChipFilterStyle = {
    height: "24px",
    fontSize: "12px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px"
  };
  return /*#__PURE__*/React.createElement(SovosChipFilter, {
    className: `${styles["severity-" + severity]}`,
    label: label,
    sx: sovosChipFilterStyle,
    icon: /*#__PURE__*/React.createElement(SovosIcon, {
      sx: {
        width: "15px",
        marginLeft: "0px !important"
      }
    }, /*#__PURE__*/React.createElement(CircleRounded, {
      sx: circleRoundedStyle
    }))
  });
};
export default AuditStatus;